import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppTokenHandler {

  public access_token_key = 'access_token';
  access_token_value = '';
  loginUserInfo!: UserInfo;
  roleList!: string[];


  getSessionToken() {
    if (sessionStorage.length > 0) {
        this.access_token_value = sessionStorage.getItem(this.access_token_key)??'';
    }
    if (this.access_token_value == null) {
        this.access_token_value = '';
    }
    return this.access_token_value;
}


  setSessionToken(loginData: any) {

    this.access_token_value = loginData.access_token;
    sessionStorage.setItem(this.access_token_key, this.access_token_value);
    sessionStorage.setItem('UserInfo', JSON.stringify(loginData));
  }

  clearSessionToken() {
    this.access_token_value = '';
    sessionStorage.removeItem('UserInfo');
    sessionStorage.removeItem(this.access_token_key);
    sessionStorage.clear();
    localStorage.removeItem('menuList');
    localStorage.clear();
  }

  getLoginUserInfo() {

    if(sessionStorage.length >0){
    this.loginUserInfo = JSON.parse(sessionStorage.getItem('UserInfo')??'');

    }
    return this.loginUserInfo;
}

  IsInRole(role: string): boolean {
    let validRole = false;
    const loginInfo: UserInfo = this.getLoginUserInfo();
    const roles: string[] = loginInfo.Roles.split(',');
    if (roles.find(x => x.indexOf(role) >= 0)) {
      validRole = true;
    }
    return validRole;
  }

  GetRolesList = (): any => {
    const loginInfo: UserInfo = this.getLoginUserInfo();
    this.roleList = loginInfo.Roles.split(',');
    return this.roleList;
  }

}

@Injectable()
export class UserInfo {
  UserId!: string;
  EmpGPN!: string;
  EmpEmail!: string;
  EmpName!: string;
  IssuedUtc!: Date;
  ExpiresUtc!: Date;
  Roles!: string;
  UserImage!: string;
  Access_token!: string;
  IsConsent!: boolean;
  IsAuthenticated!: boolean;
}

@Injectable()
export class HTTPStatus {
  private requestInFlight$: BehaviorSubject<boolean>;
  constructor() {

    this.requestInFlight$ = new BehaviorSubject<boolean>(false);
  }

  setHttpStatus(inFlight: boolean) {

    this.requestInFlight$.next(inFlight);
  }

  getHttpStatus(): Observable<boolean> {

    return this.requestInFlight$.asObservable();
  }

}
